import Fetch from "../../helpers/Fetch";
import BenefitDTO from "../dtos/Benefit";

export async function listBenefits(): Promise<BenefitDTO[]> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<BenefitDTO[]>(`/benefits`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
  })

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if (status === 'success') {
    return fetchRequest.getPayload();
  }

  throw new Error('Failed to fetch benefits');
}